<template>
  <div class="manager_dashboard">
    <UserMenu></UserMenu>
    <div class="wrapper">
			<masteradmin-sidebar-menu />
      <div class="content-wrapper"  style="background-color: #FFF;">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Pathway Catalog</h3>
            <button
                v-on:click="isModalVisible = true; this.verrors.clear();"
                class="btn btn-red btn-md input-height-15 float-right text-align-right"
                ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i> New Pathway</button>
          </div>
          <div class="heading-seperator"></div>

          <div class="col-12 pt-3" style="padding-left: 30px !important;">

						<div class="row" v-if="loading == false">
							<div class="col-12 p-0">

								<p class="" v-if="pathwayLists.length == 0 && loading == false">No pathways setup.</p>

								<div class="col-12 p-0">
									<div class="d-flex flex-wrap">
										<div class="d-flex flex-column" v-for="(pathway, index) in pathwayLists">
											<div class="pathway_content shadow rounded">
												<div class="pathway_box" :style="'border-left: 7px solid ' 
												+ pathway.ascentColor + ' !important;'">
													<p class="font-weight-bold pb-2">{{ truncate1(pathway.pathwayName) }}</p>
													<p class="flex-grow-1" style="min-height: 210px;">{{ pathway.pathwayDescription }}</p>
													<div class="row m-0">
														<div v-if="pathway.status == 'PUBLISH'" class="col pathway_status">
															Published
														</div>
														<div v-else class="col pathway_status">
															{{ pathway.status.toLowerCase() }}
														</div>
													</div>
													<div class="row m-0">
														<div class="col-10 p-0" >
															<p><a class="font-color-00acee" @click="showPathwayStep(pathway.id, pathway.isMasterAdmin)">Show Pathway</a></p>
														</div>
														<div class="col-2 text-right pr-0" >
															<b-dropdown id="dropdown-2" text="..." class=" m-0" style="margin-top: -8px !important;">
																<b-dropdown-text ><a class="dropdown-item1 bold" @click="editPathwayStep(pathway.id)">Edit</a></b-dropdown-text>
																<b-dropdown-text><a class="dropdown-item1 bold" @click="editPathwayAction(pathway)">Rename</a></b-dropdown-text>
																<b-dropdown-text  v-if="pathway.status == 'DRAFT'"><a class="dropdown-item1 bold" @click="activatePathwayConfirm(pathway.id)">Publish</a></b-dropdown-text>
																<b-dropdown-text  v-if="pathway.status == 'PUBLISH'"><a class="dropdown-item1 bold" @click="deletePathwayConfirm(pathway.id)">Archive</a></b-dropdown-text>
						                    <b-dropdown-text ><a class="dropdown-item1 bold" @click="openLogFullListModal(pathway.id)">View History</a></b-dropdown-text>
															</b-dropdown>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<CreatePathwayModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
							<div slot="header" class="sub-heading m-0"><h5 class="modal-title">Create new pathway</h5></div>
							<div slot="body" v-if="isModalVisible == true">
								<div class="col-12 override-padding">
									<div class="col-12 override-padding form-group">
										<label class="input_label" for="pathway_name">Name:<span class="required">*</span></label>
										<input v-model="pathway_name"
													name="pathway_name"
													placeholder="Name the new pathway"
													class="col-lg-12 input-text form-control line-height-30"
													v-validate="'required'"
													maxlength="140" />
										<div v-if="verrors.firstByRule('pathway_name', 'required')" class="margin-bottom-5 validate-warning-msg">Pathway Name is required</div>
									</div>
									<div class="col-12 override-padding form-group">
										<label  class="input_label" for="pathway_description">Description:</label>
										<textarea
											name="pathway_description" 
											v-model="pathway_description"
											placeholder="Describe the new pathway"
											class="textarea col-xs-12 input-text col-md-12 col-lg-12 input-height-25 form-control"
											maxlength="500" style="resize: none; height: 80px;">
											</textarea>
									</div>
                  <div class="col-12 override-padding form-group">
                    <label  class="input_label" for="pathway_description">Affiliate:<span class="required">*</span></label>
                    <div 
                      class="search-padd" 
                      id="affliate-wrapper" 
                      style="height: 27px;width: 100%;">
                      <multiselect v-model="affiliate"
                        :options="affiliate_options"
                        track-by="value"
                        label="text"
                        placeholder="Select Affiliate"
                        :multiple="true"
                        :close-on-select="false"
                        :show-labels="false"
                        v-bind:name="'affiliate[]'"
                        v-bind:id="'affiliate'"
                        v-validate="'required'">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                      </multiselect>
                    </div>
                  </div>
                  <div v-if="verrors.firstByRule('affiliate[]', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
									<div class="col-12 override-padding form-group mt-3">
										<label class="col-12 p-0 input_label" for="pathway_description">Accent color:</label>
										<div class="ascent-color-main" v-for="(color) in ascent_color">
											<div v-if="color == colors" class="ascent-color-outer" :style="'border: 1px solid '+ color">
												<div class="ascent-color1" :style="'background-color: '+ color"  @click="updateColor(color)"></div>  
											</div>
											<div v-else class="ascent-color" :style="'background-color: '+ color" @click="updateColor(color)"></div>
										</div>

										<i class="fa fa-plus-circle pickerIcon" @click="togglePicker('ADD')"></i>
									</div>

									<div class="col-12 override-padding form-group m-0" >
										<Sketch :value="colors" @input="updateFromPicker" v-show="displayPicker" class="vc-left" />
									</div>

								</div>
							</div>
							<div slot="footer" class="col-12 p-0 text-center">
								<button type="submit" class="btn btn-red btn-md input-height-15 pathway_save_btn" @click="createPathway()">Save</button>
							</div>
						</CreatePathwayModal>


						<EditPathwayModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
							<div slot="header" class="sub-heading m-0"><h6 class="modal-title">Edit pathway</h6></div>
							<div slot="body" v-if="isEditModalVisible == true">
								<div class="col-12 override-padding">
									<div class="col-12 override-padding form-group">
										<label class="input_label" for="pathway_name">Name:<span class="required">*</span></label>
										<input v-model="edit_pathway_name"
													name="edit_pathway_name"
													placeholder="Name the new pathway"
													class="col-lg-12 input-text form-control line-height-30"
													v-validate="'required'"
													maxlength="140" />
										<div v-if="verrors.firstByRule('edit_pathway_name', 'required')" class="margin-bottom-5 validate-warning-msg">Pathway Name is required</div>
									</div>
									<div class="col-12 override-padding form-group">
										<label class="input_label" for="pathway_description">Description:</label>
										<textarea
											name="edit_pathway_description" 
											v-model="edit_pathway_description"
											placeholder="Describe the new pathway"
											class="textarea col-xs-12 input-text col-md-12 col-lg-12 input-height-25 form-control"
											maxlength="500" style="resize: none; height: 80px;">
											</textarea>
									</div>
                  <div class="col-12 override-padding form-group">
                    <label  class="input_label" for="pathway_description">Affiliate:<span class="required">*</span></label>
                    <div 
                      class="search-padd" 
                      id="affliate-wrapper" 
                      style="height: 27px;width: 100%;">
                      <multiselect v-model="edit_affiliate"
                        :options="affiliate_options"
                        track-by="value"
                        label="text"
                        placeholder="Select Affiliate"
                        :multiple="true"
                        :close-on-select="false"
                        :show-labels="false"
                        v-bind:name="'edit_affiliate[]'"
                        v-bind:id="'edit_affiliate'"
                        v-validate="'required'">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                      </multiselect>
                    </div>
                  </div>
                  <div v-if="verrors.firstByRule('edit_affiliate[]', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
									<div class="col-12 override-padding form-group mt-3">
										<label class="col-12 p-0 input_label" for="pathway_description">Accent color:</label>
										<div class="ascent-color-main" v-for="(color) in edit_ascent_color">
											<div v-if="color == edit_colors" class="ascent-color-outer" :style="'border: 1px solid '+ color">
												<div class="ascent-color1" :style="'background-color: '+ color"  @click="updateEditColor(color)"></div>  
											</div>
											<div v-else class="ascent-color" :style="'background-color: '+ color" @click="updateEditColor(color)"></div>
										</div>

										<i class="fa fa-plus-circle pickerIcon" @click="togglePicker('EDIT')"></i>
									</div>

									<div class="col-12 override-padding form-group m-0">
										<Sketch :value="edit_colors" @input="updateEditFromPicker" v-show="displayPicker" class="vc-left" />
									</div>

								</div>
							</div>
							<div slot="footer" class="col-12 p-0 text-center">
								<button type="submit" class="btn btn-red btn-md input-height-15 pathway_save_btn"  @click="editPathway()">Save</button>
							</div>
						</EditPathwayModal>


						<DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
							<span v-if="loading" class="pull-right text-danger">
								Loading...
							</span>
							<div slot="header" class="sub-heading">Are you sure you want to archive the pathway?</div>
							<div slot="body">

							</div>
							<div slot="footer" class="col-3 override-padding">
								<button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; updatePathwayStatus(id, 'ARCHIVE')">Confirm</button>
							</div>
						</DeleteModal>


						<ActivateModal :isModalVisible="isActivateModalVisible" :id="id"  @close="isActivateModalVisible = false">
							<span v-if="loading" class="pull-right text-danger">
								Loading...
							</span>
							<div slot="header" class="sub-heading">Are you sure you want to publish the pathway?</div>
							<div slot="body">

							</div>
							<div slot="footer" class="col-3 override-padding">
								<button class="left col-12 btn btn-red" @click="isActivateModalVisible = false; updatePathwayStatus(activateId, 'PUBLISH')">Confirm</button>
							</div>
						</ActivateModal>

						<LogFullList 
							:isModalVisible="isLogFullListVisible"
							@closeLogFullListModal="closeLogFullListModal"
							ref="LogFullListModal">
						</LogFullList>

					</div>
				</div>
			</div>
		</div>
	</div>



</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import UserMenu from '@/components/shared/user_menu.vue';
import CreatePathwayModal from '../admin/create-pathway-modal.vue';
import EditPathwayModal from '../admin/create-pathway-modal.vue';
import ColourPicker from 'vue-colour-picker';
import { Sketch } from 'vue-color'
//import 'bootstrap/js/dist/dropdown.js';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";
import router from '../../router/index.js';
import ActivateModal from '../shared/delete_modal_alert.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import LogFullList from '@/components/admin/master_admin_pathway_catalog_audit_log_full_list.vue';
import Multiselect from 'vue-multiselect';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
        props: ['accountId'],
        data() {
          return {
            pathwayCount: '',
            isModalVisible: false,
            isEditModalVisible: false,
            pathway_name: '',
            pathway_description: '',
            displayPicker: false,
            colors: '#2EACEE',
            ascent_color: [
              '#2EACEE',
              '#9A54A6',
              '#EC511F',
            ],
            pathwayLists: [],
            loading: false,
            edit_pathway_name: '',
            edit_pathway_id: '',
            edit_pathway_description: '',
            edit_colors: '#2EACEE',
            edit_ascent_color: [
              '#2EACEE',
              '#9A54A6',
              '#EC511F',
            ],
            isDeleteModalVisible: false,
            isActivateModalVisible: false,
            id: '',
            activateId: '',
            isLogFullListVisible: false,
            isAssignAccountsListVisible: false,
            isLogFullListVisible: false,
            affiliate_options: [],
            affiliate: '',
            edit_affiliate: '',
          }
        },
        components: {
          CreatePathwayModal,
          ColourPicker,
          Sketch,
          EditPathwayModal,
          ActivateModal,
          DeleteModal,
					UserMenu,
					MasteradminSidebarMenu,
          LogFullList,
          Multiselect,
        },
        methods: {
          openLogFullListModal(pathwayId) {
            this.$refs.LogFullListModal.getActivityData(pathwayId);
            this.isLogFullListVisible = true;
          },
          closeLogFullListModal() {
            this.isLogFullListVisible = false;
          },
          openAssignAccountsListModal(pathwayId) {
            this.$refs.AssignAccountsListModal.getAccounts(pathwayId);
            this.isAssignAccountsListVisible = true;
          },
          closeAssignAccountsListModal() {
            this.isAssignAccountsListVisible = false;
          },
          openLogFullListModal(pathwayId) {
            this.$refs.LogFullListModal.getActivityData(pathwayId);
            this.isLogFullListVisible = true;
          },
          closeLogFullListModal() {
            this.isLogFullListVisible = false;
          },
          truncate1: function (text) {
            if (text.length > 25) {
                return text.substring(0, 25) + '...';
            } else {
                return text;
            }
          },
          activatePathwayConfirm(id) {

            axios('/check-pathway-has-steps/' + id,
            {
                method: 'GET',
            })
            .then(resp => {
              if(resp.data.flag == 1) {
                alert(resp.data.msg);
                return false;
              }
              else {
                this.isActivateModalVisible = true;
                this.activateId = id;
              }
            })
            .catch(() => {
            });

          },
          deletePathwayConfirm: function(id) {
            this.isDeleteModalVisible = true;
            this.id = id;
          },

          updatePathwayStatus(id, status_text) {
            axios('/edit-pathway/' + id,
             {
               method: 'PATCH',
               data: { "status": status_text},
             }
            )
            .then((resp) => {
              this.getPathwayLists();
              this.id = '';
              this.activateId = '';
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
          },
          resourceRedirect() {
            router.push('/resourses');
          },
          truncate: function (text) {
            if (text.length > 150) {
                return text.substring(0, 150) + '...';
            } else {
                return text;
            }
          },
          editPathwayAction(pathway) {
            this.edit_pathway_id = pathway.id;
            this.edit_pathway_name = pathway.pathwayName;
            this.edit_pathway_description = pathway.pathwayDescription;
            this.edit_affiliate = pathway.affiliate;
            this.edit_colors = pathway.ascentColor;
            if(this.edit_ascent_color.indexOf(this.edit_colors) === -1) {
              this.edit_ascent_color.push(this.edit_colors);
            }
            this.isEditModalVisible = true;
          },
          editPathway: function() {
            this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              axios('/edit-pathway/' + this.edit_pathway_id,
                 {
                   method: 'PATCH',
                   data:
                    {
                      pathway_name: this.edit_pathway_name,
                      pathway_description: this.edit_pathway_description,
                      ascent_color: this.edit_colors,
                      affiliate_selected: this.edit_affiliate,
                    },
                 }
               )
              .then((resp) => {
                  this.getPathwayLists();
                  this.isEditModalVisible = false;
                  this.edit_pathway_name = '';
                  this.edit_pathway_description = '',
                  this.displayPicker = '',
                  this.edit_pathway_id = '';
                  this.edit_colors = '#2EACEE';
                  this.edit_ascent_color = [];
                  this.edit_affiliate = '';
                  this.edit_ascent_color = [
                    '#2EACEE',
                    '#9A54A6',
                    '#EC511F',
                  ];
                  this.verrors.clear();
               })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
              });
            }
            });
          },
          clonePathwayStep: function(pathwayId) {
            this.loading = true;
            axios('/clone-pathway/' + pathwayId,
              {
                method: 'POST',
              }
            )
            .then((resp) => {
               this.getPathwayLists();
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
            
          },
          showPathwayStep: function(pathwayId, isMasterAdmin) {
            this.$store.dispatch('pathway_steps', '');
            router.push("/masteradmin-pathway-catalog-step-show-pathway/" + pathwayId);
          },
          editPathwayStep: function(pathwayId) {
            this.$store.dispatch('pathway_steps', '');
            router.push("/masteradmin-pathway-catalog-step-builder/" + pathwayId);
          },
          createPathway: function() {
            this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              axios('/create-pathway-catalog',
                 {
                   method: 'POST',
                   data:
                    {
                      pathway_name: this.pathway_name,
                      pathway_description: this.pathway_description,
                      ascent_color: this.colors,
                      affiliate_selected: this.affiliate,
                    },
                 }
               )
              .then((resp) => {

                  this.getPathwayLists();
                  this.isModalVisible = false;
                  this.pathway_name = '';
                  this.pathway_description = '',
                  this.displayPicker = '',
                  this.colors = '#2EACEE';
                  this.ascent_color = [];
                  this.affiliate = '';
                  this.ascent_color = [
                    '#2EACEE',
                    '#9A54A6',
                    '#EC511F',
                  ];
                  this.verrors.clear();
									this.editPathwayStep(resp.data);
               })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
              });
            }
            });
          },
          getPathwayLists() {
            this.pathwayLists = [];
            this.loading = true;
            axios('/get-pathway-catalog',
               {
                 method: 'GET',
               }
             )
            .then((resp) => {
                this.loading = false;
                this.pathwayCount = resp.data.length;
                this.pathwayLists = resp.data;
             })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
          },
          showPicker() {
            document.addEventListener('click', this.documentClick);
            this.displayPicker = true;
          },

          hidePicker() {
            document.removeEventListener('click', this.documentClick);
            this.displayPicker = false;
          },
          togglePicker(type) {
            if(type == 'ADD') {
              var colorslen = this.ascent_color.length;
            }
            else {
              var colorslen = this.edit_ascent_color.length;
            }
            if(colorslen >= 10) {
              alert("You can add only 10 colors.");
              return false;
            }
            else {
              this.displayPicker ? this.hidePicker() : this.showPicker();
            }
          },
          updateFromPicker(color) {
            this.colors = color.hex;
            if(this.ascent_color.indexOf(this.colors) === -1) {
              this.ascent_color.push(this.colors);
            }
            this.displayPicker = false;
          },
          updateColor(color) {
            this.colors = color;
          },
          updateEditFromPicker(color) {
            this.edit_colors = color.hex;
            if(this.edit_ascent_color.indexOf(this.edit_colors) === -1) {
              this.edit_ascent_color.push(this.edit_colors);
            }
            this.displayPicker = false;
          },
          updateEditColor(color) {
            this.edit_colors = color;
          },
          fetchAffiliateOptions: function() {
            axios.get('/affiliateoptions', {

            })
            .then((response) => {
              var affiliate_option = {value: '', text: 'Select Affiliate'};
              this.affiliate_options.push(affiliate_option);
              for(var i=0; i < response.data.length; i++) {
                var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                this.affiliate_options.push(affiliate_option);
              }
            })
            .catch(error => {
            });
          },
        },
        created() {
          this.getPathwayLists();
          this.fetchAffiliateOptions();
        },
}
</script>
<style scoped>
a, a:hover, a:focus {
  cursor: pointer; 
}
.pathway_box {
  border-color: lightgray !important;
  border-left: 7px solid #00ACEE !important;
  border-radius: 7px !important;
  background-color: white !important;
  padding: 8px 10px 5px 10px;
}
.
.pathway_box p {
  margin-bottom: 3px;
}

.d-flex div.pathway_box {
  margin-right: 0px;
  width: 240px;
  background-color: burlywood;
}

.pathway_box .dropdown button {
  margin-top: -10px;
}

.pathway_box .dropdown button:focus {
  box-shadow: unset;
}

.accent_color_add {
  height: 23px;
  width: 23px;
  display: inline-flex;
  background-color: #e9e9e9;
  color: #646e71;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.pathway_save_btn {
  padding: 0px 10px !important;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 400;
  width: 80px; height: 35px;
}
</style>
<style >
.vc-sketch {
    position: absolute !important;
    top: -260px !important;
    left: 50px !important;
}
.ascent-color {
  height: 15px;
  width: 15px;
  border-radius: 10px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.ascent-color1 {
  height: 12px;
  width: 12px;
  border-radius: 10px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.ascent-color-main {
  float: left;
  margin-right: 10px;
}
.ascent-color-outer {
  float: left;
  padding: 0px 2px 2px 2px;
  border-radius: 15px;
  margin-top: 1px;
}
.dropdown-item {
  cursor: pointer;
  color: #BBB !important;
}
#dropdown-2 .dropdown-toggle::after{
  display: none;
}
#dropdown-2 .dropdown-toggle {
  background: none;
  border: 0;
  color: #002F42;
  font-weight: bold;
}
#dropdown-2 .dropdown-menu {
  margin: 0px;
  padding: 0px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 110px;
}
#dropdown-2 .b-dropdown-text {
  margin-bottom: 0px;
}
#dropdown-2 .b-dropdown-text {
  cursor: pointer;
  color: #848884 !important;
  padding: 2px 5px 2px 10px;
  font-size: 14px;
}
#dropdown-2.dropdown a, #dropdown-2.dropdown a:hover {
  font-size: 15px;
  color: #848884 !important;
  font-weight: bold;
}
#dropdown-2 .dropdown-item:hover, #dropdown-2 .dropdown-item:active, #dropdown-2 .dropdown-item:focus, #dropdown-2.dropdown a:hover, #dropdown-2.dropdown a:focus, #dropdown-2.dropdown a:active {
  background: none !important;
  text-decoration: none !important;
}
.pathwayBtn, .pathwayBtn:hover, .pathwayBtn:focus {
  padding: 7px 7px; border-radius: 15px !important;
  width: 150px;
	text-transform: uppercase;
}
.top-content {
  min-height: 80px;padding-top: 15px !important; padding-bottom: 10px !important;
}
.pathway_content {
  margin-bottom: 25px; margin-right: 25px;
}
.pathway_status {
  font-size: 12px;
  font-style: italic;
  text-align: right;
  padding-right: 0px;
  text-transform: capitalize;
}
.pickerIcon {
  cursor: pointer; font-size: 17px; margin-top: 2px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#affliate-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#affliate-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/master_admin_pathway_catalog_lists.vue